import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Popper,
  Select,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import SearchIcon from "@mui/icons-material/Search";
import {
  getSearchExactItemAPI,
  onGetAttributesBoxPallet_Truck,
  onGetBoxPallet_Ledger_Report,
  onGetBoxPallet_Pending_Report,
  onGetBoxPallet_Report,
} from "./BoxPalletReportAction";
import {
  CmpDatePicker,
  CmpRadioButton,
} from "../../Component/Common/ToolBox/ToolBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import ItemSearchModal from "./ItemSearchModal";
import axios from "axios";
import { getGlobals } from "../../Configs";
import moment from "moment";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";

const BoxPalletReport = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:1200px)");
  const location = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const baseURL = getGlobals().API_BASE_URL;
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const locationSelectRef = useRef(null);
  const [searchModal, setSearchModal] = useState(false);
  const [truckData, setTruckData] = useState([]);
  const [selectedTrucks, setSelectedTrucks] = useState([]);
  const [filterData, setFilterData] = useState({
    Location: vRdxuserLoc.length > 0 ? [vRdxuserLoc[0]?.UID] : [],
    Truck: [],
    AllTrucks: [],
    bReportType: "Itemwise",
    fromDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
      1,
      0,
      0
    ),
    toDate: new Date(),
    itemCode: "",
    itemName: "",
  });
  console.log(">>>", filterData, selectedTrucks);

  const isAllSelected = selectedTrucks.length === filterData.AllTrucks?.length;

  const handleSelectAll = (event) => {
    const newSelectedTrucks = event.target.checked
      ? filterData.AllTrucks || []
      : [];
    setSelectedTrucks(newSelectedTrucks);
    setFilterData((prev) => ({
      ...prev,
      Truck: newSelectedTrucks,
    }));
  };

  const handleChange = (event, value) => {
    const filteredValue = value.filter((v) => v.UId !== "select-all");
    setSelectedTrucks(filteredValue);
    setFilterData((prev) => ({
      ...prev,
      Truck: filteredValue,
    }));
  };

  const isSelected = (option) =>
    selectedTrucks.some((truck) => truck.UId === option.UId);

  const [data, setData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const itemWiseColumns = [
    { field: "ItmCd", headerName: "Code", width: 95 },
    {
      field: "ItemName",
      headerName: "Name",
      width: xMediaQuery ? 200 : 0,
      flex: xMediaQuery ? 0 : 1,
    },
    { field: "TruckId", headerName: "Truck Id", width: 100, hide: true },
    { field: "TruckName", headerName: "Truck Name", width: 200 },
    {
      field: "Qty",
      headerName: "Qty",
      alignItems: "center",
      valueFormatter: ({ value }) => (value != null ? Number(value) : ""),
      width: 80,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Loading",
      headerName: "Loading",
      width: 100,
      alignItems: "center",
    },
    {
      field: "Issuing",
      headerName: "Issuing",
      width: 100,
      alignItems: "center",
    },
  ];
  // Sample columns for the DataGrid
  const Pendingcolumns = [
    { field: "A_VocNo", headerName: "Voc No", width: xMediaQuery ? 90 : 120 },
    { field: "DcoTypeName", headerName: "DcoTypeName", width: 150 },
    { field: "ItmCd", headerName: "Item Code", width: 100, hide: true },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: xMediaQuery ? 200 : 0,
      flex: xMediaQuery ? 0 : 1,
    },
    { field: "TruckId", headerName: "Truck Id", width: 200 },
    { field: "TruckName", headerName: "Truck Name", width: 150 },
    {
      field: "Qty",
      headerName: "Qty",
      width: 80,
      headerAlign: "center",
      align: "center",
      valueFormatter: ({ value }) => (value != null ? Number(value) : ""),
    },
  ];
  const Ledgercolumns = [
    { field: "VocNo", headerName: "Voc No", width: xMediaQuery ? 90 : 120 },
    {
      field: "VocTypName",
      headerName: "VocTyp Name",
      width: xMediaQuery ? 120 : 150,
    },
    { field: "ItmCd", headerName: "Item Code", width: 100, hide: true },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: xMediaQuery ? 200 : 0,
      flex: xMediaQuery ? 0 : 1,
    },
    { field: "TruckName", headerName: "Truck Name", width: 200 },
    {
      field: "PostDt",
      headerName: "PostDt",
      width: 100,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "Receipt", headerName: "Receipt", width: 70 },
    { field: "Issue", headerName: "Issue", width: 70 },
    {
      field: "RunningQty",
      headerName: "RunningQty",
      width: 90,
      headerAlign: "center",
      align: "center",
    },
  ];

  const fetchBoxPalletItemWise = async (truck) => {
    if (filterData?.Location?.length == 0 || truck?.length == 0) {
      fAlertToast("FAILED", "Location and truck should not be empty");
      return;
    }
    const obj = {
      Loc: (filterData?.Location).toString(),
      TruckId: truck?.map((truck) => truck.UId).toString(),
    };

    const response = await onGetBoxPallet_Report(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setData(GridID);
    } else {
      setData([]);
    }
  };

  // Load data from the API based on selected location and truck
  const fetchBoxPalletPending = async (truck) => {
    if (filterData?.Location?.length == 0 || truck?.length == 0) {
      fAlertToast("FAILED", "Location and truck should not be empty");
      return;
    }
    let truckId = truck?.map((truck) => truck.UId).toString();
    const obj = {
      Loc: (filterData?.Location).toString(),
      TruckId: truckId,
    };

    const response = await onGetBoxPallet_Pending_Report(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setPendingData(GridID);
    } else {
      setPendingData([]);
    }
  };
  const fetchTruckData = async () => {
    const response = await onGetAttributesBoxPallet_Truck();
    if (response?.status === 200) {
      const allTrucks = response?.data?.ResultSet?.TruckRec;
      // const initialTruck = allTrucks.length > 0 ? [allTrucks[0]] : [];
      setTruckData(allTrucks);
      setFilterData((prev) => ({
        ...prev,
        // Truck: initialTruck,
        AllTrucks: allTrucks, // Store all trucks for dropdown options
      }));
      // setSelectedTrucks(initialTruck);
      await fetchBoxPalletItemWise();
    }
  };
  const fetchBoxPalletLedger = async (truck) => {
    if (filterData?.Location?.length == 0 || truck?.length == 0) {
      fAlertToast("FAILED", "Location and truck should not be empty");
      return;
    }
    let truckId = truck.map((truck) => truck.UId).toString();
    const obj = {
      Location: (filterData?.Location).toString(),
      TruckId: truckId,
      Date1: moment(filterData?.fromDate).format("MM/DD/YYYY"),
      Date2: moment(filterData?.toDate).format("MM/DD/YYYY"),
      ItmCd: filterData?.itemCode,
    };
    const response = await onGetBoxPallet_Ledger_Report(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200) {
      let GridID = response?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setLedgerData(GridID);
    } else {
      setLedgerData([]);
    }
  };

  // Load data from the API based on selected location and truck
  const getExactItemSearch = async () => {
    const obj = {
      anyData: filterData?.itemName,
      transType: "F",
      report: "Y",
      loc: (filterData?.Location).toString(),
    };

    const response = await getSearchExactItemAPI(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200) {
      if (response?.data?.ResultSet?.length == 1) {
        setFilterData((prev) => ({
          ...prev,
          itemCode: response?.data?.ResultSet[0]?.ItmCd || "",
          itemName: response?.data?.ResultSet[0]?.Name1 || "",
        }));
      } else if (response?.data?.ResultSet?.length == 0) {
        setSearchModal(true);

        setTimeout(() => {
          document.getElementById("anyDataDes")?.focus();
        }, 1000);
      } else {
        setFilterData((prev) => ({
          ...prev,
          itemCode: "",
          itemName: "",
        }));
        fAlertToast("FAILED", "No matching item found.");
      }
    } else {
      setFilterData([]);
    }
  };

  const handleDetailChange = (field, value, event = null) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const fOpenItemSearchModal = (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      getExactItemSearch();
    }
    if (e?.key === "Backspace") {
      setFilterData((prev) => ({
        ...prev,
        itemCode: "",
      }));
    }
  };

  const handleLoad = () => {
    if (filterData.bReportType === "Itemwise") {
      setPendingData([]);
      setLedgerData([]);
      fetchBoxPalletItemWise(filterData.Truck);
    } else if (filterData.bReportType === "PendingTransaction") {
      setData([]);
      setLedgerData([]);
      fetchBoxPalletPending(filterData.Truck);
    } else {
      setData([]);
      setPendingData([]);
      fetchBoxPalletLedger(filterData.Truck);
    }
  };

  useEffect(() => {
    if (locationSelectRef.current) {
      locationSelectRef.current.focus();
    }
    fetchTruckData();
  }, []);

  return (
    <Box sx={{ p: { xs: 0, sm: 1 }, pt: { xs: 1, sm: 2 } }}>
      <Grid container spacing={{ xs: 1, sm: 2 }} mb={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={filterData.bReportType !== "Ledger" ? 3.5 : 6}
          lg={filterData.bReportType !== "Ledger" ? 4 : 2.8}
        >
          <FormControl size="small" fullWidth>
            <InputLabel id="location-select-label">Location</InputLabel>
            <Select
              labelId="location-select-label"
              id="location-select"
              multiple
              value={filterData.Location}
              onChange={(event) => {
                const { value } = event.target;
                if (value.includes("all")) {
                  setFilterData((prev) => ({
                    ...prev,
                    Location:
                      filterData.Location.length === vRdxuserLoc.length
                        ? []
                        : vRdxuserLoc.map((loc) => loc.UID),
                  }));
                  return;
                }
                setFilterData((prev) => ({
                  ...prev,
                  Location: value,
                }));
              }}
              label="Location"
              displayEmpty
              inputRef={locationSelectRef}
              renderValue={(selected) => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "20px",
                    overflowY: "auto",
                  }}
                >
                  {selected.map((value) => (
                    <Box
                      key={value}
                      sx={{
                        whiteSpace: "nowrap",
                        padding: "2px 4px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        margin: "2px 0",
                      }}
                    >
                      {vRdxuserLoc.find((loc) => loc.UID === value)?.Name1 ||
                        value}
                    </Box>
                  ))}
                </Box>
              )}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    width: 250,
                  },
                },
              }}
            >
              <MenuItem value="all">
                <Checkbox
                  checked={filterData.Location.length === vRdxuserLoc.length}
                  indeterminate={
                    filterData.Location.length > 0 &&
                    filterData.Location.length < vRdxuserLoc.length
                  }
                />
                <ListItemText primary="Select All" />
              </MenuItem>
              {vRdxuserLoc.map((locationItem) => (
                <MenuItem key={locationItem.UID} value={locationItem.UID}>
                  <Checkbox
                    checked={filterData.Location.includes(locationItem.UID)}
                  />
                  <ListItemText primary={locationItem.Name1} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={filterData.bReportType !== "Ledger" ? 3.5 : 6}
          lg={filterData.bReportType !== "Ledger" ? 4 : 2.7}
        >
          <Autocomplete
            multiple
            size="small"
            options={[
              { UId: "select-all", Name1: "Select All" },
              ...(filterData.AllTrucks || []),
            ]}
            getOptionLabel={(option) => option?.Name1 || ""}
            value={selectedTrucks}
            isOptionEqualToValue={(option, value) => option?.UId === value?.UId}
            onChange={handleChange}
            disableCloseOnSelect
            PopperComponent={(props) => (
              <Popper
                {...props}
                style={{
                  zIndex: 1300,
                }}
                placement="bottom-start"
              />
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Truck Name"
                placeholder="Search..."
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "38px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                  },
                }}
              />
            )}
            renderOption={(props, option, { selected }) => {
              if (option.UId === "select-all") {
                return (
                  <MenuItem
                    {...props}
                    sx={{
                      height: "31px",
                      minHeight: "31px",
                      padding: "0 8px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      size="small"
                      checked={isAllSelected}
                      indeterminate={
                        selectedTrucks.length > 0 &&
                        selectedTrucks.length < filterData.AllTrucks?.length
                      }
                      onChange={handleSelectAll}
                    />
                    <ListItemText
                      primary="Select All"
                      primaryTypographyProps={{
                        fontSize: "12px",
                        lineHeight: "1.2",
                      }}
                    />
                  </MenuItem>
                );
              }

              return (
                <MenuItem
                  {...props}
                  sx={{
                    height: "31px",
                    minHeight: "31px",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Checkbox size="small" checked={isSelected(option)} />
                  <ListItemText
                    primary={option?.Name1}
                    primaryTypographyProps={{
                      fontSize: "12px",
                      lineHeight: "1.2",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  />
                </MenuItem>
              );
            }}
          />
        </Grid>
        {filterData.bReportType === "Ledger" && (
          <>
            <Grid
              item
              xs={6}
              sm={2.8}
              md={3}
              lg={1.5}
              sx={{
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px !important",
                },
                "& .MuiTextField-root": {
                  width: "100% !important",
                },
              }}
            >
              <CmpDatePicker
                xLabelText={"From Date"}
                xValue={filterData.fromDate}
                xOnChange={(newValue) =>
                  setFilterData((obj) => ({
                    ...obj,
                    fromDate: newValue.$d,
                  }))
                }
                xName={"fromDate"}
                xError={false}
                xErrorMessage={false}
              />
            </Grid>
            <Grid
              item
              xs={6}
              sm={2.7}
              md={3}
              lg={1.5}
              sx={{
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px !important",
                },
                "& .MuiTextField-root": {
                  width: "100% !important",
                },
              }}
            >
              <CmpDatePicker
                fullWidth
                xLabelText={"To Date"}
                xValue={filterData.toDate}
                xOnChange={(newValue) =>
                  setFilterData((obj) => ({
                    ...obj,
                    toDate: newValue.$d,
                  }))
                }
                xName={"toDate"}
                xError={false}
                xErrorMessage={false}
              />
            </Grid>
          </>
        )}

        <Grid
          item
          xs={12}
          // sm={6}
          sm={filterData.bReportType !== "Ledger" ? 8 : 6.5}
          md={filterData.bReportType !== "Ledger" ? 5 : 5.5}
          // lg={4}
          lg={filterData.bReportType !== "Ledger" ? 4 : 3.5}
        >
          <CmpRadioButton
            value="Itemwise"
            label="Itemwise"
            checked={filterData.bReportType === "Itemwise"}
            onChange={(e) => {
              setFilterData((obj) => ({
                ...obj,
                bReportType: e.target.value,
              }));
            }}
          />
          <CmpRadioButton
            value="PendingTransaction"
            label="Pending Transaction"
            checked={filterData.bReportType === "PendingTransaction"}
            onChange={(e) => {
              setFilterData((obj) => ({
                ...obj,
                bReportType: e.target.value,
              }));
            }}
          />
          <CmpRadioButton
            value="Ledger"
            label="Ledger"
            checked={filterData.bReportType === "Ledger"}
            onChange={(e) => {
              setFilterData((obj) => ({
                ...obj,
                bReportType: e.target.value,
              }));
              fetchBoxPalletLedger();
            }}
          />
        </Grid>
        {filterData.bReportType === "Ledger" && (
          <>
            <Grid
              item
              xs={4}
              sm={filterData.bReportType !== "Ledger" ? 6 : 3}
              md={3}
              lg={3}
              sx={{
                "& .MuiInputLabel-root": {
                  top: "-8px !important",
                },
                "& .MuiInputLabel-shrink": {
                  top: "-0px !important",
                },
              }}
              // mt={vMediaQuery ? 1.5 : xMediaQuery ? 0 : 0}
            >
              <TextField
                sx={{
                  "& .MuiOutlinedInput-input": {
                    padding: vMediaQuery
                      ? "15px 14px !important"
                      : "10px 14px !important",
                  },
                }}
                label="Item Code"
                value={filterData?.itemCode}
                onChange={(event) =>
                  handleDetailChange("itemCode", event.target.value, event)
                }
                fullWidth
                // error={errors?.itemCode === "" ? false : true}
                // helperText={errors?.itemCode}
                disabled={true}
                autoComplete="off"
              />
            </Grid>
            <Grid
              item
              xs={8}
              sm={filterData.bReportType !== "Ledger" ? 10.5 : 7.5}
              md={8}
              lg={8}
              sx={{
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px !important",
                },
                "& .MuiInputLabel-root": {
                  top: "-8px !important",
                },
                "& .MuiInputLabel-shrink": {
                  top: "-0px !important",
                },
              }}
              // mt={vMediaQuery ? 1.5 : xMediaQuery ? 0 : 0}
            >
              <TextField
                label="Item Name"
                value={filterData.itemName}
                onChange={(event) =>
                  handleDetailChange("itemName", event.target.value)
                }
                name={"itemName"}
                fullWidth
                // error={errors?.itemName === "" ? false : true}
                // helperText={errors?.itemName}
                onKeyUp={fOpenItemSearchModal}
                autoComplete="off"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={fOpenItemSearchModal}>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </>
        )}

        <Grid
          item
          xs={12}
          sm={filterData.bReportType !== "Ledger" ? 4 : 1}
          md={filterData.bReportType !== "Ledger" ? 12 : 1}
          lg={filterData.bReportType !== "Ledger" ? 12 : 1}
          textAlign={vMediaQuery ? "center" : "right"}
        >
          <Button
            variant="contained"
            sx={{ width: "10%" }}
            onClick={handleLoad}
          >
            Load
          </Button>
        </Grid>
      </Grid>
      {/* <Divider /> */}
      <Grid
        container
        spacing={{ xs: 0.5, sm: 1, md: 2, lg: 3 }}
        mt={"8px !important"}
      ></Grid>

      <Box
        sx={{
          height: {
            xs: filterData.bReportType !== "Ledger" ? "65vh" : "56vh",
            sm: "68vh",
            md: "68vh",
            lg: "70vh",
          },
          width: "100%",
          mt: vMediaQuery ? 0 : 2,
        }}
      >
        {filterData.bReportType === "Itemwise" && (
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            rows={data}
            columns={itemWiseColumns}
            getRowId={(row) => row.id}
            components={{
              Toolbar: GridToolbar,
            }}
            hideFooter
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
          />
        )}

        {filterData.bReportType === "PendingTransaction" && (
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            rows={pendingData}
            columns={Pendingcolumns}
            getRowId={(row) => row.id}
            components={{
              Toolbar: GridToolbar,
            }}
            hideFooter
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
          />
        )}
        {filterData.bReportType === "Ledger" && (
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            rows={ledgerData}
            columns={Ledgercolumns}
            getRowId={(row) => row.id}
            components={{
              Toolbar: GridToolbar,
            }}
            hideFooter
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
              
            }}
          />
        )}
      </Box>

      <CmpModal
        open={searchModal}
        onClose={() => setSearchModal(false)}
        title="Item Search"
        width={vMediaQuery ? "95%" : xMediaQuery ? "85%" : "70%"}
        height={vMediaQuery ? "80vh" : "65vh"}
        component={
          <ItemSearchModal
            open={searchModal}
            //  xMediaQuery={xMediaQuery}
            handleClose={() => setSearchModal(false)}
            handleRowClick={(item) => {
              setFilterData((prev) => ({
                ...prev,
                itemCode: item.ItmCd,
                itemName: item.Name1,
              }));
              // setErrors(initError);
              setSearchModal(false);
            }}
            location={filterData?.Location}
            anyDataItemName={filterData?.itemName}
          />
        }
      />
    </Box>
  );
};

export default BoxPalletReport;
